import { utilities } from '~/common';
import { SalesCourseBundle } from '~/types';

import { PriceInfo } from './PriceInfo';

export const getBundleDiscount = (bundle: SalesCourseBundle): PriceInfo => {
  return {
    originalPrice: utilities.getCourseBundlePrice(bundle, false),
    discount: { value: { percentOff: bundle.discount_percent } },
  };
};
